import {
	COMPONENT_STATES,
	COMPONENT_TYPE,
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	DEFAULT_MEDIA_QUERY_SIZES,
} from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import type { StoryDictionaryMap } from 'common/i18n/types';
import { convertPxToVw } from 'utils/helpers';
import { BUTTON_SHAPE_TYPES } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

type ButtonType = typeof COMPONENT_TYPE.BUTTON | typeof COMPONENT_TYPE.BUTTON_SUBMIT;

export const createButtonDefaults = ({ dictionary }: { dictionary: StoryDictionaryMap }, type: ButtonType) => ({
	componentProps: {
		other: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
					[OTHER_PROPS.button.buttonShapeType]: BUTTON_SHAPE_TYPES.SQUARED,
				},
			},
		},
		styles: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
					backgroundColor: 'rgb(0, 168, 126)',
				},
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DESKTOP]: {
					width: convertPxToVw(240, 2, DEFAULT_MEDIA_QUERY_SIZES.desktop.min),
					height: convertPxToVw(60, 2, DEFAULT_MEDIA_QUERY_SIZES.desktop.min),
					fontSize: convertPxToVw(20, 2, DEFAULT_MEDIA_QUERY_SIZES.desktop.min),
					borderRadius: '6px',
				},
				[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {
					width: convertPxToVw(160, 2, 375),
					height: convertPxToVw(40, 2, 375),
					fontSize: convertPxToVw(18, 2, 375),
				},
			},
			[COMPONENT_STATES.HOVER]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
					backgroundColor: 'rgb(0, 196, 148)',
				},
			},
		},
	},
	children: {
		[COMPONENT_STATES.DEFAULT]: {
			[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: dictionary[type].text,
		},
	},
});

export const button = (
	context: CreationContextFor<typeof COMPONENT_TYPE.BUTTON>
): CreatedBuildingBlock<typeof COMPONENT_TYPE.BUTTON> =>
	createModel({
		type: COMPONENT_TYPE.BUTTON,
		...createButtonDefaults(context, COMPONENT_TYPE.BUTTON),
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.BUTTON>;
